import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TypeSessionUser } from '@/types/auth/types.auth.session';

type TypeSessionStatus = 'unknown' | 'anonymous' | 'authenticated';

type TypeAuthState = {
    status: TypeSessionStatus;
    user: TypeSessionUser | null;
};

const initialState: TypeAuthState = { status: 'unknown', user: null };

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        sessionOpened: (state, action: PayloadAction<{ user: TypeSessionUser }>) => {
            state.status = 'authenticated';
            state.user = action.payload.user;
        },
        sessionRefreshed: (state, action: PayloadAction<TypeSessionUser>) => {
            state.user = action.payload;
        },
        sessionClosed: (state) => {
            state.status = 'anonymous';
            state.user = null;
        },
    },
});

export const { sessionOpened, sessionRefreshed, sessionClosed } = authSlice.actions;

export default authSlice.reducer;
